<div class='content-wrapper'>
    <div>      
        <div class="button-wrapper">
            <img src="./assets/images/shield-logo.svg" alt="אייקון מגן" class="login-option-img">
            <p>פורטל הורים עובר להזדהות הלאומית</p>
            <p class="small-text">הזדהות מאובטחת אחת לקבלת שירותים ומידע 
                מהממשלה ומהרשות המקומית</p>
        
            <p-button icon="pi pi-chevron-left" iconpos="left" label="הכניסה מכאן" (click)="redirectGov()"></p-button>  
            <p class="dev-by gov-il">
                פותח ונתמך ע"י  
                <img src="./assets/images/gov-il.svg" alt="gov-il">
            </p>
        </div>
          
    </div>
</div>